import React, { Component } from "react";
import { Checkbox } from "antd";
import { RightOutlined } from "@ant-design/icons";

import { BottomButton } from "./bottom-button/bottom-button";
// import { submit, carConvert } from './car-event';
import { apiVehicle } from "../../../api/api-vehicle";
import { alert } from "../../../common/utils/alert";

const layout = {
  labelCol: { span: 10 },
  wrapperCol: { span: 14 },
};

const contractOptions = [
  { label: "Thêm hợp đồng", value: 0 },
  { label: "Chỉnh sửa hợp đồng", value: 1 },
  { label: "Xem chi tiết/Lịch sử chỉnh sửa hợp đồng", value: 2 },
  { label: "Xóa/Hủy hợp đồng", value: 3 },
  { label: "Gán hợp đồng", value: 4 },
];

const journeyDiaryOptions = [
  { label: "Khóa chỉnh sửa NKHT", value: 0 },
  { label: "Chỉnh sửa NKHT", value: 1 },
  { label: "Xem chi tiết NKHT", value: 2 },
  { label: "Xuất Payment Request", value: 3 },
  { label: "Gán NKHT", value: 4 },
];

const driverOptions = [
  { label: "Thêm tài xế", value: 0 },
  { label: "Chỉnh sửa thông tin tài xế", value: 1 },
  { label: "Xem chi tiết thông tin tài xế", value: 2 },
  { label: "Xóa thông tin tài xế", value: 3 },
  { label: "Gán tài xế", value: 4 },
];

const vehicleOptions = [
  { label: "Thêm xe", value: 0 },
  { label: "Chỉnh sửa thông tin xe", value: 1 },
  { label: "Xem chi tiết thông tin xe", value: 2 },
  { label: "Xóa thông tin xe", value: 3 },
  { label: "Gán xe", value: 4 },
];

const exportOptions = [
  { label: "Xuất báo cáo kinh doanh dài hạn", value: 0 },
  { label: "Xuất báo cáo Overkm", value: 1 },
  { label: "Xuất báo cáo Overtime", value: 2 },
  { label: "Xuất báo cáo chi phí vé", value: 3 },
];

const customerOptions = [
  { label: "Thêm khách hàng", value: 0 },
  { label: "Chỉnh sửa thông tin khách hàng", value: 1 },
  { label: "Xem chi tiết thông tin khách hàng", value: 2 },
  { label: "Xóa thông tin khách hàng", value: 3 },
];

const userAccountOptions = [
  { label: "Thêm tài khoản", value: 0 },
  { label: "Chỉnh sửa tài khoản", value: 1 },
  { label: "Xem chi tiết tài khoản", value: 2 },
  { label: "Xóa tài khoản", value: 3 },
];

const permissionOptions = [
  { label: "Thêm vai trò", value: 0 },
  { label: "Chỉnh sửa vai trò", value: 1 },
  { label: "Xem chi tiết vai trò", value: 2 },
  { label: "Xóa vai trò", value: 3 },
];

//Sử dụng Ref cho vấn đề cập nhật lại UI trong các Component con
export class AddUserPermission extends Component {
  state = {
    editable: true,
    editPage: false,
    typeOption: "create_new",
    inactiveDelete: false,
    contractRoles: [],
    journeyDiaryRoles: [],
    customerRoles: [],
    driverRoles: [],
    vehicleRoles: [],
    exportRoles: [],
    permissionRoles: [],
    userAccountRoles: [],
  };

  // async componentDidMount() {
  //     const carOptions = await apiVehicle.getCarOptions();
  //     if (carOptions.status === 'success') {
  //         this.dataOptions = carOptions.data;
  //         this.setOptionState();
  //     }
  // }

  // setOptionState = () => {
  //     if (!this.dataOptions) {
  //         return;
  //     }
  //     const { branches, fuel_groups, supplier_groups, operation_admins, unit_operators, accountants } = this.dataOptions;
  //     this.carOwner && this.carOwner.setState({
  //         fuel_groups: fuel_groups.map(item => { return { ...item, code: item.id } }),
  //         supplier_groups: supplier_groups.map(item => { return { ...item, code: item.id } }),
  //         branches: branches.map(item => { return { ...item, code: item.id, name: item.code } })
  //     });
  //     this.carManagement && this.carManagement.setState({
  //         operation_admins: operation_admins.map(item => { return { ...item, code: item.id } }),
  //         unit_operators: unit_operators.map(item => { return { ...item, code: item.id } }),
  //         accountants: accountants.map(item => { return { ...item, code: item.id } })
  //     })
  // }

  // submit = async () => {
  //     submit(this);
  // }

  // deleteCar = () => {
  //     Modal.confirm({
  //         title: "Xóa xe",
  //         icon: null,
  //         content: 'Bạn có chắc chắn muốn xóa xe này không?',
  //         okText: 'Có',
  //         okType: 'danger',
  //         cancelText: 'Không',
  //         confirmLoading: this.state.confirmLoading,
  //         onOk: async () => {
  //             this.setState({ confirmLoading: true })

  //             apiVehicle.deleteCar(this.state.carIdEdit).then(response => {
  //                 this.setState({ confirmLoading: false })
  //                 if (response.status === 'success') {
  //                     alert('success', 'Xóa xe thành công!')
  //                     this.props.close();
  //                 } else {
  //                     alert('error', response.data.message)
  //                 }
  //             }).catch(err => {
  //                 this.setState({ confirmLoading: false })
  //             })
  //         },
  //         onCancel() {
  //         },
  //         className: 'del-comfirm'
  //     })
  // }

  // setCarStatusType = carStatusType => {
  //     this.setState({ carStatusType })
  // }

  // goToCarDetail = () => {
  //     if (this.carParam)
  //         this.updateFormCar(this.carParam)
  // }

  // updateFormCar = (car) => {
  //     if (car.owner === 'AVIS') {
  //         this.carOwner.setState({ isAvisCar: true })
  //     }
  //     if(car.in_contract){
  //         this.setState({
  //             inactiveDelete: true
  //         })
  //     }
  //     this.carParam = car;
  //     this.setState({ editable: false, typeOption: 'show_detail', editPage: true, carIdEdit: car.id });
  //     this.carManagement && this.carManagement.setState({
  //         in_current_journey_diary: car.current_journey_diary_id ? true : false,
  //         in_current_contract: car.current_contract_id ? true : false,
  //         carStatus: car.status,
  //     })
  //     carConvert(car, this)
  // }

  // enableEdit = () => {
  //     this.setState({ editable: true, typeOption: 'edit' })
  // }

  // cancelEdit = () => {
  //     this.setState({ editable: false, typeOption: 'show_detail' });
  // }

  checkEditPass = (v) => {
    if (!this.state.checkEditPass) {
      this.setState({ checkEditPass: true });
      this.form.setFieldsValue({
        password: "",
      });
    } else {
      this.form.setFieldsValue({
        password: v,
      });
    }
  };

  handleChangeContractRoles = (value) => {
    const { permissionRoles } = this.state;
    if (permissionRoles.includes(0) && !value.includes(4)) {
      value.push(4);
      this.setState({
        contractRoles: value,
      });
    }
    if (
      (value.includes(1) && !value.includes(2)) ||
      (value.includes(3) && !value.includes(2))
    ) {
      value.push(2);
      this.setState({
        contractRoles: value,
      });
    } else {
      this.setState({
        contractRoles: value,
      });
    }
  };

  handleChangeJourneyDiaryRoles = (value) => {
    if (
      (value.includes(1) && !value.includes(2)) ||
      (value.includes(3) && !value.includes(2))
    ) {
      value.push(2);
      this.setState({
        journeyDiaryRoles: value,
      });
    } else {
      this.setState({
        journeyDiaryRoles: value,
      });
    }
  };

  handleChangeCustomerRoles = (value) => {
    if (value.includes(0)) {
      this.setState({
        customerRoles: [0, 1, 2, 3],
      });
    } else if (
      (value.includes(1) && !value.includes(2)) ||
      (value.includes(3) && !value.includes(2))
    ) {
      value.push(2);
      this.setState({
        customerRoles: value,
      });
    } else {
      this.setState({
        customerRoles: value,
      });
    }
  };

  handleChangeAccountRoles = (value) => {
    if (value.includes(0)) {
      const {
        contractRoles,
        journeyDiaryRoles,
        driverRoles,
        vehicleRoles,
      } = this.state;
      this.setState({
        userAccountRoles: [0, 1, 2, 3],
      });
      if (!contractRoles.includes(4)) {
        contractRoles.push(4);
        this.setState({
          contractRoles: contractRoles,
        });
      }
      if (!journeyDiaryRoles.includes(4)) {
        journeyDiaryRoles.push(4);
        this.setState({
          journeyDiaryRoles: journeyDiaryRoles,
        });
      }
      if (!driverRoles.includes(4)) {
        driverRoles.push(4);
        this.setState({
          driverRoles: driverRoles,
        });
      }
      if (!vehicleRoles.includes(4)) {
        vehicleRoles.push(4);
        this.setState({
          vehicleRoles: vehicleRoles,
        });
      }
    } else if (
      (value.includes(1) && !value.includes(2)) ||
      (value.includes(3) && !value.includes(2))
    ) {
      value.push(2);
      this.setState({
        userAccountRoles: value,
      });
    } else {
      this.setState({
        userAccountRoles: value,
      });
    }
  };

  handleChangeDriverRoles = (value) => {
    if (
      (value.includes(1) && !value.includes(2)) ||
      (value.includes(3) && !value.includes(2))
    ) {
      value.push(2);
      this.setState({
        driverRoles: value,
      });
    } else {
      this.setState({
        driverRoles: value,
      });
    }
  };

  handleChangeExportRoles = (value) => {
    this.setState({
      exportRoles: value,
    });
  };

  handleChangeReviewRoles = (value) => {};

  handleChangeVehicleRoles = (value) => {
    if (
      (value.includes(1) && !value.includes(2)) ||
      (value.includes(3) && !value.includes(2))
    ) {
      value.push(2);
      this.setState({
        vehicleRoles: value,
      });
    } else {
      this.setState({
        vehicleRoles: value,
      });
    }
  };

  handleChangePermissionRoles = (value) => {
    if (value.includes(0)) {
      const {
        contractRoles,
        journeyDiaryRoles,
        driverRoles,
        vehicleRoles,
      } = this.state;
      this.setState({
        permissionRoles: [0, 1, 2, 3],
      });
      if (!contractRoles.includes(4)) {
        contractRoles.push(4);
        this.setState({
          contractRoles: contractRoles,
        });
      }
      if (!journeyDiaryRoles.includes(4)) {
        journeyDiaryRoles.push(4);
        this.setState({
          journeyDiaryRoles: journeyDiaryRoles,
        });
      }
      if (!driverRoles.includes(4)) {
        driverRoles.push(4);
        this.setState({
          driverRoles: driverRoles,
        });
      }
      if (!vehicleRoles.includes(4)) {
        vehicleRoles.push(4);
        this.setState({
          vehicleRoles: vehicleRoles,
        });
      }
    } else if (
      (value.includes(1) && !value.includes(2)) ||
      (value.includes(3) && !value.includes(2))
    ) {
      value.push(2);
      this.setState({
        permissionRoles: value,
      });
    } else {
      this.setState({
        permissionRoles: value,
      });
    }
  };

  render() {
    const {
      typeOption,
      editable,
      editPage,
      inactiveDelete,
      contractRoles,
      journeyDiaryRoles,
      customerRoles,
      driverRoles,
      vehicleRoles,
      userAccountRoles,
      permissionRoles,
    } = this.state;
    return (
      <div className="add-user-permission">
        <div className="add-new-user-title">
          <span onClick={this.props.close}>
            Danh sách vai trò
            <RightOutlined style={{ margin: "0px 7px" }} />
          </span>
          {typeOption === "create_new"
            ? "Thêm vai trò mới"
            : typeOption === "show_detail"
            ? "Chi tiết vai trò"
            : "Chỉnh sửa vai trò"}
        </div>
        <table className="selection-roles">
          <tbody>
            <tr>
              <td className="title-roles">Hợp đồng</td>
              <td>
                <Checkbox.Group
                  className="checkbox-style"
                  onChange={(v) => this.handleChangeContractRoles(v)}
                  options={contractOptions}
                  value={contractRoles}
                />
              </td>
              <td className="title-roles">Nhật ký hành trình</td>
              <td>
                <Checkbox.Group
                  className="checkbox-style"
                  onChange={(v) => this.handleChangeJourneyDiaryRoles(v)}
                  options={journeyDiaryOptions}
                  value={journeyDiaryRoles}
                />
              </td>
            </tr>
            <tr>
              <td className="title-roles">Tài xế</td>
              <td>
                <Checkbox.Group
                  className="checkbox-style"
                  onChange={(v) => this.handleChangeDriverRoles(v)}
                  options={driverOptions}
                  value={driverRoles}
                />
              </td>
              <td className="title-roles">Xe</td>
              <td>
                <Checkbox.Group
                  className="checkbox-style"
                  onChange={(v) => this.handleChangeVehicleRoles(v)}
                  options={vehicleOptions}
                  value={vehicleRoles}
                />
              </td>
            </tr>
            <tr>
              <td className="title-roles">Export</td>
              <td>
                <Checkbox.Group
                  className="checkbox-style"
                  onChange={(v) => this.handleChangeExportRoles(v)}
                  options={exportOptions}
                />
              </td>
              <td className="title-roles">Khách hàng</td>
              <td>
                <Checkbox.Group
                  className="checkbox-style"
                  onChange={(v) => this.handleChangeCustomerRoles(v)}
                  options={customerOptions}
                  value={customerRoles}
                />
              </td>
            </tr>
            <tr>
              <td className="title-roles">Tài khoản người dùng</td>
              <td>
                <Checkbox.Group
                  className="checkbox-style"
                  onChange={(v) => this.handleChangeAccountRoles(v)}
                  options={userAccountOptions}
                  value={userAccountRoles}
                />
              </td>
              <td className="title-roles">Phân quyền người dùng</td>
              <td>
                <Checkbox.Group
                  className="checkbox-style"
                  onChange={(v) => this.handleChangePermissionRoles(v)}
                  options={permissionOptions}
                  value={permissionRoles}
                />
              </td>
            </tr>
            <tr>
              <td className="title-roles">Nhận xét</td>
              <td colSpan="3">
                <Checkbox onChange={(v) => this.handleChangeReviewRoles(v)}>
                  Xem nhận xét đánh giá{" "}
                </Checkbox>
              </td>
            </tr>
          </tbody>
        </table>
        <BottomButton
          typeOption={typeOption}
          enableEdit={this.enableEdit}
          submit={this.submit}
          cancelEdit={this.cancelEdit}
          close={this.props.close}
          deleteCar={this.deleteCar}
          inactiveDelete={inactiveDelete}
          goToDetailCar={this.goToDetailCar}
        />
      </div>
    );
  }
}
